import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../../reducers/setting/password";

function loadDataAPI() {
  return axios.get(`/api/mb/member/my-info`);
}

function* loadData({ payload }) {
  console.log("payload: ============================== ", payload);

  try {
    const response = yield call(loadDataAPI);
    console.log("response: ", response);
    console.log("response.data.data.member: ", response.data.data.member);

    yield put({
      type: actions.LOAD_DATA_SUCCESS,
      payload: response.data.data.member,
    });
  } catch (error) {
    console.log("error: ", error);
  }
}

function* watchLoadData() {
  yield takeEvery(actions.LOAD_PW_DATA, loadData);
}

export default function* settingPasswordSaga() {
  yield all([fork(watchLoadData)]);
}
